import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { codeList, giftBatchList } from "@/api/gmtool/packageCode";
import addCode from "./components/addCode.vue";
import articles from "./components/articles.vue";
import other from "./components/other.vue";
export default {
  name: "packageCode",
  components: {
    addCode: addCode,
    articles: articles,
    other: other
  },
  data: function data() {
    return {
      test: true,
      advanced: false,
      dialog: false,
      total: 0,
      list: [],
      BatchList: [],
      paramsData: {
        is_special: '',
        code_type: '',
        page: 1
      }
    };
  },
  created: function created() {
    this.getbatchList();
  },
  methods: {
    getbatchList: function getbatchList() {
      var _this = this;

      giftBatchList(this.paramsData).then(function (res) {
        _this.BatchList = res.data.query_list;
      });
    },
    // 关闭弹窗
    changeShow: function changeShow(val) {
      this.dialog = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.paramsData.page = val;
      this.getList();
    },
    getList: function getList() {
      var _this2 = this;

      codeList(this.paramsData).then(function (res) {
        _this2.list = res.data.data;
        _this2.total = res.data.total;
      });
    },
    search: function search() {
      this.paramsData.page = 1;

      if (this.paramsData.is_special == 0 && !this.paramsData.code_type) {
        this.$message.error('请选择礼包类型');
        return;
      }

      this.getList();
    },
    // 删除配置
    handleDelete: function handleDelete(data) {
      var _this3 = this;

      this.$confirm("此操作将删除该礼包码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delgiftcode({
                  id: data.id,
                  gen_id: data.gen_id
                }).then(function (res) {
                  _this3.getList();

                  _this3.$message({
                    type: "success",
                    message: '删除成功'
                  });
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};